module.exports = __webpack_public_path__ + "media/images/defaultmascot-1e2a21fa2a011b7bc07a19ecddcf2a29.svg";